export default {
  title: "",
  subtitle:'',
  path: "person_totals",
  paragraph: '',
  request: {
    method: "GET", 
    endpoint: "/subject/:id/transaction_values",
    responses: {
      "data": [
        {
          "value": "30111.00",
          "exchanged_value": "5660.97",
          "exchange_currency": "USD",
          "currency": "BRL",
          "count": 7
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonTotals.js